/**
 * new Date().getTime() wrapper for easier mocking in tests
 */
export const getTime = () => new Date().getTime();
